module.exports = __webpack_public_path__ + "assets/img/news (52).6c98ac45.png";